'use strict';

class Service {
    menuData;
    menuController;

    constructor() {
    }

    initMenuController(menuController, prop, isPresenter) {
        try {
            if (!this.menuData) {
                this.initItem(isPresenter);
                parseMenuChildren(this.menuController, prop, isPresenter);
            }
            this.menuData.isPresenter = prop.isPresenter;
            this.menuData.isViewer = prop.isViewer;
            this.menuData.isVisible = prop.isVisible;
            menuController.appendMenuItem(LobbyMenu.menuItemName, prop.text || this.menuData.text, this.menuData);
        } catch (error) {
            console.error("Error in Lobby menu. Error: " + error);
        }
    }

    initItem(isPresenter) {
        this.menuData = new MenuData(LobbyMenu.text, 1, 8);
        this.menuData.isListTypeMenu = true;

        this.menuController = new MenuController(this.menuData);
        this.menuController.setMenuControlParameter(VR.scene, iq3Camera.camera, wv.selectionSphere);
        this.menuController.setMenuItemWidth(.23);
        this.menuController.setMenuItemHeight(.03);
        this.menuController.setTextAlignType(TextAlignTypeEnum.left);

        this.menuController.addCommandMenuItem(
            new ClickMenuItem("Allow", "Allow", null, this.allow.bind(this)).setIsViewer(false)
        );
        this.menuController.addCommandMenuItem(
            new ClickMenuItem("AllowAll", "Allow All", null, this.allowAll.bind(this)).setIsViewer(false)
        );

        this.menuController.addCommandMenuItem(
            new ClickMenuItem("Deny", "Deny", null, this.deny.bind(this)).setIsViewer(false)
        );

        this.menuController.addCommandMenuItem(
            new ClickMenuItem("DenyAll", "Deny All", null, this.denyAll.bind(this)).setIsViewer(false)
        );
    }

    addUserToLobby(userId, name) {
        if (this.menuData === undefined) {
            this.initItem(is_current_user_presenter());
        }

        let menuItems = this.getAllAvailablePeopleInLobbyInfoFromMenu();

        if (menuItems.some(participant => participant.userData.participantName === name)) {
            return;
        }
        let menuItem = new ToggleCheckTypeMenuItem(userId, name, false, null, {
            participantName: name,
        }, ToggleActionType.ALL_USER);

        menuItems.push(menuItem);

        let participantMenuView = mController.menuDataView.getThisMenuView(LobbyMenu.menuItemName);
        let participantMenuData = mController.menuData.getThisMenuData(LobbyMenu.menuItemName);

        completelyRemoveThisMenuView(mController, participantMenuView, LobbyMenu.menuItemName);
        this.menuController.menuData.removeAllItems();

        if (participantMenuView && participantMenuView.isMenuDrawn()) {
            menuItems.forEach(item => {
                participantMenuView.insertThisMenuItemToRunningMenuData(LobbyMenu.menuItemName, item);
                participantMenuView.refresh();
            });
        } else {
            menuItems.forEach(item => {
                if (participantMenuData) {
                    participantMenuData.addItem(item);
                } else {
                    this.menuController.appendMenuItem(undefined, undefined, item);
                }
            });
        }

        if (dummyMenuController) {
            let participantMenuView = dummyMenuController.menuDataView.getThisMenuView(LobbyMenu.menuItemName);
            let participantMenuData = dummyMenuController.menuData.getThisMenuData(LobbyMenu.menuItemName);

            completelyRemoveThisMenuView(dummyMenuController, participantMenuView, LobbyMenu.menuItemName);

            if (participantMenuView && participantMenuView.isMenuDrawn()) {
                menuItems.forEach(item => {
                    participantMenuView.insertThisMenuItemToRunningMenuData(LobbyMenu.menuItemName, item);
                    participantMenuView.refresh();
                });
            } else {
                menuItems.forEach(item => {
                    if (participantMenuData) {
                        participantMenuData.addItem(item);
                    } else {
                        this.menuController.appendMenuItem(undefined, undefined, item);
                    }
                });
            }
        }
    }

    removeUserFromLobby(userID) {
        let menuItems = this.getAllAvailablePeopleInLobbyInfoFromMenu();

        let participantMenuView = mController.menuDataView.getThisMenuView(LobbyMenu.menuItemName);
        let participantMenuData = mController.menuData.getThisMenuData(LobbyMenu.menuItemName);
        completelyRemoveThisMenuView(mController, participantMenuView, LobbyMenu.menuItemName);

        const index = menuItems.findIndex(item => item.userData.participantName === userID);


        if (index !== -1) {
            menuItems.splice(index, 1);
        }

        completelyRemoveThisMenuView(mController, participantMenuView, LobbyMenu.menuItemName);
        this.menuController.menuData.removeAllItems();

        if (participantMenuView && participantMenuView.isMenuDrawn()) {
            menuItems.forEach(item => {
                participantMenuView.insertThisMenuItemToRunningMenuData(LobbyMenu.menuItemName, item);
                participantMenuView.refresh();
            });
        } else {
            menuItems.forEach(item => {
                if (participantMenuData) {
                    participantMenuData.addItem(item);
                } else {
                    this.menuController.appendMenuItem(undefined, undefined, item);
                }
            });
        }

        if (dummyMenuController) {
            let participantMenuView = dummyMenuController.menuDataView.getThisMenuView(LobbyMenu.menuItemName);
            let participantMenuData = dummyMenuController.menuData.getThisMenuData(LobbyMenu.menuItemName);

            completelyRemoveThisMenuView(dummyMenuController, participantMenuView, LobbyMenu.menuItemName);

            if (participantMenuView && participantMenuView.isMenuDrawn()) {
                menuItems.forEach(item => {
                    participantMenuView.insertThisMenuItemToRunningMenuData(LobbyMenu.menuItemName, item);
                    participantMenuView.refresh();
                });
            } else {
                menuItems.forEach(item => {
                    if (participantMenuData) {
                        participantMenuData.addItem(item);
                    } else {
                        this.menuController.appendMenuItem(undefined, undefined, item);
                    }
                });
            }
        }
    }

    getAllAvailablePeopleInLobbyInfoFromMenu() {
        let info = [];

        if (this.menuController) {
            getInfoFromMenuData(this.menuController.menuData);
        }

        function getInfoFromMenuData(menuData) {
            menuData.items.forEach((item) => {
                if (item instanceof SubMenuItem) {
                    let subMenuData = item.subMenuData;
                    getInfoFromMenuData(subMenuData);
                } else {
                    info.push(item);
                }
            })
        }

        return info;
    }

    allow() {
        let selectedItems = getSelectedToggleTypeItems(this.menuData);
        const meetingID = getMeetingIdFromURL();
        const payload = {
            names: [],
            meetingID: meetingID
        };
        selectedItems.forEach(item => {
            payload.names.push(item.userData.participantName)
        });
        allowUserToJoin(payload);

    }

    allowAll() {
        let selectedItems = getAllToggleTypeItems(this.menuData);
        const meetingID = getMeetingIdFromURL();
        const payload = {names: [], meetingID: meetingID};
        selectedItems.forEach(item => {
            payload.names.push(item.userData.participantName)
        });
        allowUserToJoin(payload);
    }

    deny() {
        let selectedItems = getSelectedToggleTypeItems(this.menuData);
        const meetingID = getMeetingIdFromURL();
        const payload = {
            names: [],
            meetingID: meetingID,
            presenterName: wv.currentPresenterName
        };
        selectedItems.forEach(item => {
            payload.names.push(item.userData.participantName)
        });
        denyUserToJoin(payload);

    }

    denyAll() {
        let selectedItems = getAllToggleTypeItems(this.menuData);
        const meetingID = getMeetingIdFromURL();
        const payload = {names: [], meetingID: meetingID, presenterName: wv.currentPresenterName};
        selectedItems.forEach(item => {
            payload.names.push(item.userData.participantName)
        });
        denyUserToJoin(payload);
    }

    callLobbyReminder(time) {
        const notifyPresenter = () => {
            const users = this.getAllAvailablePeopleInLobbyInfoFromMenu();

            if (users && users.length > 0 && is_current_user_presenter()) {
                VRMessageController.addMessage({text: "Users are waiting in the Lobby. Please accept or deny"});
            } else if (users.length === 0) {
                clearInterval(this.lobbyInterval);
            }
        };

        if (this.lobbyInterval) clearInterval(this.lobbyInterval);
        this.lobbyInterval = setInterval(notifyPresenter, time);
    }
    
}

export default Service;